import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/**
 * Porte l'explication d'un contrôle désactivé — sur un conteneur, pas sur le contrôle.
 *
 * SOLY-PERM-001. La classe de base de `buttonVariants` (`components/ui/button.tsx`) contient
 * `disabled:pointer-events-none` : un `<Button disabled title="…">` est retiré du hit-testing,
 * donc il ne reçoit **aucun survol** et son `title` natif ne s'affiche dans aucun navigateur.
 * Le bouton grisé reste alors muet — exactement ce que `PERMISSION_DENIED_HINT` existe pour
 * éviter (« un bouton qui disparaît se lit comme un bug ; un bouton grisé qui dit pourquoi
 * enseigne le modèle de droits »).
 *
 * Les `<button>` natifs du planning n'ont pas ce problème : ils utilisent
 * `disabled:cursor-not-allowed`, qui ne touche pas au hit-testing. Ce wrapper ne sert donc que
 * pour les `<Button>` shadcn.
 *
 * `hint` à `undefined` = rien à expliquer : aucun conteneur n'est rendu, la mise en page est
 * strictement celle d'avant. Quand il y en a une, `className` doit reproduire la boîte que le
 * bouton occupait (`block w-full` pour un bouton pleine largeur) — sinon le span shrink-wrap et
 * un `w-full` sur l'enfant ne mesure plus la même chose.
 */
export function DisabledHint({
  hint,
  className,
  children,
}: {
  hint?: string
  className?: string
  children: ReactNode
}) {
  if (!hint) return <>{children}</>
  return (
    <span title={hint} className={cn('inline-flex', className)}>
      {children}
    </span>
  )
}
